<div class="flex justify-center items-center">
  <div class="py-5 mt-10 w-full max-w-xl bg-white rounded-lg border border-100">
    <div class="px-8 border-b border-100">
      <h1 class="mb-4 text-lg font-semibold text-text-900">
        Dentista selecionado
      </h1>
    </div>

    <div class="px-16 py-4">
      <div class="flex flex-col gap-4">
        <div class="py-3 border-b border-100">
          <div class="flex justify-between items-center">
            <h2 class="flex items-center text-lg font-semibold text-text-950">
              {{ doctor.physicianName }}
            </h2>
            @if (!isAccredited) {
              <app-not-accredited-badge />
            }
          </div>

          <p class="text-text-700">
            {{ 'CRO ' + doctor.physicianCro }}
          </p>
        </div>

        <div class="pb-3 border-b border-100">
          <div class="flex justify-between mb-2">
            <h2 class="text-base font-semibold text-text-950">Especialidade</h2>
            @if (isAccredited) {
              <div class="flex gap-1 items-center">
                <img src="star-icon.svg" class="mr-1 w-5 h-5" alt="Star Icon" />
                <span class="text-xl font-bold text-text-700">
                  {{ score }}
                </span>
              </div>
            }
          </div>
          <p class="text-text-700">Dentística</p>
        </div>

        <div class="flex gap-1">
          <img src="location.svg" class="mr-1 w-5 h-5" alt="Location Icon" />
          <p class="text-text-700">
            {{ getDoctorCompleteAddress() }}
          </p>
        </div>

        <div class="flex flex-col gap-6">
          <span class="text-sm font-bold text-indicator-info">
            {{ distance }}km de distância
          </span>

          @if (doctor.physicianEmail) {
            <p class="font-semibold text-text-950">
              {{ doctor.physicianEmail }}
            </p>
          }

          <div class="flex gap-2 items-center">
            <i class="material-symbols-outlined !text-xl"> phone </i>
            <p class="font-semibold text-text-950">
              {{ doctor.physicianPhone | phone }}
            </p>
          </div>

          @if (!isAccredited) {
            <app-alert
              class="mt-6"
              title="Dentista não credenciado"
              message="Entre em contato com o dentista para efetuar o credenciamento e garantir a aquisição do cupom."
            />
          }
        </div>
      </div>
    </div>

    <div class="px-8 pt-4 mt-4 w-full">
      <div class="grid grid-cols-2 gap-3">
        <app-button
          label="Voltar"
          buttonType="secondary"
          buttonAction="default"
          (handleClick)="goBack()"
          fullSize="true"
        />
        <app-button
          label="Avançar"
          buttonType="solid"
          buttonAction="default"
          (handleClick)="goNext()"
          [disabled]="!isAccredited"
          fullSize="true"
        />
      </div>
    </div>
  </div>
</div>
